import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WaterBodyTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WaterBodyTypeModel._instance == null) WaterBodyTypeModel._instance = new WaterBodyTypeModel(authManager);
        return WaterBodyTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/water-body-types', 'geo-sections/water-body-types/codelist');

        this.entityName = 'geo-sections.WaterBodyType';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Water Body Type';
        this.setLabel = 'Water Body Types';

        this.browser = {
            name: 'default-geo-sections-waterbodytype-browser',
            moduleName: 'default-geo-sections-waterbodytype-browser',
            moduleTitle: 'Water Body Types',
            moduleStateSlotName: 'default-geo-sections-waterbodytype-browser',
        };

        this.editor = {
            name: 'default-geo-sections-waterbodytype-editor',
            moduleName: 'default-geo-sections-waterbodytype-editor',
            moduleTitle: 'Water Body Type',
            moduleStateSlotName: 'default-geo-sections-waterbodytype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
